.root > p {
  margin-bottom: 0.75rem;
}

.root > p:last-child {
  margin-bottom: 0;
}

.dataRange {
  margin: 1rem 0;
  white-space: nowrap;
}

.dataRange > span {
  margin-left: 0.5rem;
  font-weight: 700;
  color: var(--h5w-domainControls--colorAlt, #333);
}

.autoscale {
  display: flex;
  align-items: center;
  margin: 0 0 1rem;
}

.autoscale > button:first-of-type {
  margin-left: 0.5rem;
}

.actionBtn {
  composes: btnClean from '../../utils.module.css';
  display: flex;
  align-items: center;
  padding: 0.25rem;
  font-size: 1.125em;
  border-radius: 0.5rem;
  transition:
    background-color 0.05s ease-in-out,
    box-shadow 0.05s ease-in-out;
}

.actionBtn:hover {
  background-color: var(--h5w-btn-hover--bgColor, whitesmoke);
  box-shadow: -1px -1px 2px inset var(--h5w-btnRaised--shadowColor, gray);
}

.actionBtn:active {
  box-shadow: 1px 1px 2px inset var(--h5w-btnRaised--shadowColor, gray);
}

.error {
  display: flex;
  align-items: flex-start;
  min-height: 2rem;
  margin: -0.25rem 0 1rem;
  color: var(--h5w-error--color, brown);
}

.errorMessage {
  flex: 1;
  font-size: 0.9375em;
  font-weight: 600;
}

.errorMessage > svg {
  vertical-align: -0.125em;
}

.errorMessage > strong {
  font-weight: bold;
}

.swapBtn {
  composes: actionBtn;
  font-size: 1.5em;
}
